module.exports = __webpack_public_path__ + "img/52114136_L.315c79fe.png";